import React, { useState, useRef, useEffect } from 'react';
import { GENDERS } from '../constants/index';

const SelectInput = ({ title, list, style, onChange, label, value, error }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');

  const [pressed, setPressed] = useState('');
  const [pointer, setPointer] = useState(0);

  useEffect(() => {
    if (pressed === 'ArrowUp') {
      setPointer(pointer !== 0 ? pointer - 1 : list.length - 1);
    }

    if (pressed === 'ArrowDown') {
      setPointer(pointer !== 0 ? pointer - 1 : list.length - 1);
    }
  }, [pressed]);

  const OutsideClickRef = useRef(null);

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  });

  useEffect(() => {
    setSelected(list.find(item => item.code === value));
    setIsOpen(false);
  }, [value]);

  const handleSelect = (e, item, index) => {
    e.preventDefault();
    if (isOpen) {
      setPointer(index);
      setSelected(item);
      onChange(item.code);
      setIsOpen(false);
    }
  };

  const handleOutsideClick = (e) => {
    if (OutsideClickRef.current && !OutsideClickRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const handlePressedArrow = (key) => {
    if (key === 'Enter') {
      setSelected(list[pointer]);
      setIsOpen(!isOpen);
    } else setPressed(key);
  };

  return (
    <div className="select-wrapper" ref={OutsideClickRef} style={style}>
      {label && <label className="label" >{label}</label>}
      <div style={label ? { marginTop: '8px' } : {}} className="select-header main-select-header" onClick={() => setIsOpen(!isOpen)} tabIndex={0}
        onKeyDown={({ key }) => {
          handlePressedArrow(key);
        }}
      >
        <div className="select-header-title" >{selected && list === GENDERS?selected.label.en: selected? (selected.label.ar || selected.label) : title}</div>
        <i className="fa fa-chevron-down"></i>
      </div>

      {isOpen && <div className="select-list">
        {
          list.map((listItem, index) => {
            return <button
              key={index}
              className="select-list-item"
              onClick={(e) => handleSelect(e, listItem, index)}
              style={{
                cursor: 'pointer',
                backgroundColor: index === pointer ? 'gray' : 'black',
                width:'100%'
              }}
              aria-pressed={index === pointer}
              value={listItem}
            >
              {list === GENDERS ? listItem.label.en :listItem.label.ar || listItem.label}
            </button>;
          })
        }
      </div>}
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default SelectInput;